import _defineProperty from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import React, { useContext } from 'react';
import { List, ListItem, TAGTypography, TAGLink, RichText, Grid, Box, FacilityContext } from '../..';
import { useTheme } from '@mui/material/styles';

var OurServices = function OurServices(props) {
  var _facilityState$addres, _facilityState$addres2, _facilityState$addres3, _facilityState$addres4, _facilityState$addres5, _facilityState$addres6, _sx;

  var branding = props.branding,
      emergency = props.emergency,
      description = props.ourServicesDescription,
      personalizedServices = props.personalizedServices;
  var theme = useTheme();

  var _useContext = useContext(FacilityContext),
      facilityState = _useContext.state;

  var groupNames = _toConsumableArray(new Set(personalizedServices.map(function (item) {
    return item.groupName;
  })));

  var transformedData = groupNames.map(function (groupName) {
    return {
      groupName: groupName,
      groupLinks: personalizedServices.map(function (service) {
        if (service.groupName === groupName) {
          return {
            serviceType: service.serviceType,
            link: service.link
          };
        }
      }).filter(function (item) {
        return item;
      })
    };
  });
  var state = (_facilityState$addres = facilityState.address) === null || _facilityState$addres === void 0 ? void 0 : (_facilityState$addres2 = _facilityState$addres.state) === null || _facilityState$addres2 === void 0 ? void 0 : _facilityState$addres2.toLowerCase();
  var city = (_facilityState$addres3 = facilityState.address) === null || _facilityState$addres3 === void 0 ? void 0 : (_facilityState$addres4 = _facilityState$addres3.city) === null || _facilityState$addres4 === void 0 ? void 0 : _facilityState$addres4.toLowerCase().replace(/ /gi, '-');
  var line1 = (_facilityState$addres5 = facilityState.address) === null || _facilityState$addres5 === void 0 ? void 0 : (_facilityState$addres6 = _facilityState$addres5.line1) === null || _facilityState$addres6 === void 0 ? void 0 : _facilityState$addres6.toLowerCase().replace(/ /gi, '-').replace(/[,\.]/gi, '');
  var profileURL = "/dentist/profile/".concat(state, "/").concat(city, "/").concat(line1);
  return React.createElement(React.Fragment, null, React.createElement(Grid, {
    container: true,
    justifyContent: "flex-start"
  }, React.createElement(Grid, {
    item: true
  }, React.createElement(TAGTypography, {
    variant: "bodyMediumBook",
    sx: {
      paddingLeft: '16px',
      display: 'flex'
    }
  }, description))), transformedData && React.createElement(Box, {
    sx: (_sx = {
      display: 'grid',
      width: '100%',
      gridColumnGap: '15px',
      overflow: 'hidden',
      margin: '10px 0'
    }, _defineProperty(_sx, theme.breakpoints.up('xs'), {
      gridTemplateColumns: "repeat(1, 100%)"
    }), _defineProperty(_sx, theme.breakpoints.up('sm'), {
      gridTemplateColumns: "repeat(2, 5fr)"
    }), _defineProperty(_sx, theme.breakpoints.up('md'), {
      gridTemplateColumns: "repeat(3, 5fr)"
    }), _defineProperty(_sx, theme.breakpoints.up('lg'), {
      gridTemplateColumns: "repeat(4, 5fr)"
    }), _sx)
  }, transformedData.map(function (data, i) {
    return React.createElement(Grid, {
      item: true,
      key: i
    }, React.createElement(List, null, React.createElement(ListItem, {
      sx: {
        paddingBottom: '0px'
      }
    }, React.createElement(TAGTypography, {
      variant: "bodyMediumSemiBold"
    }, data.groupName)), data.groupLinks.map(function (groupItem) {
      return React.createElement(ListItem, {
        key: groupItem.serviceType,
        sx: {
          paddingBottom: '0px'
        }
      }, groupItem.link ? React.createElement(TAGLink, {
        href: "".concat(profileURL).concat(groupItem.link),
        underline: "always"
      }, groupItem.serviceType) : React.createElement(TAGTypography, null, groupItem.serviceType, " "));
    })));
  })), React.createElement(Grid, {
    container: true,
    justifyContent: "center"
  }, React.createElement(Grid, {
    item: true
  }, React.createElement(RichText, {
    centerAlign: false,
    content: emergency,
    branding: branding
  }))));
};

export default OurServices;